import React from 'react'
import { Grid, Typography } from '@mui/material'

function Safety() {
  return (
    <Grid className='dflex height70vh' justifyContent='center'>
         <Typography className='font20'>Coming Soon...</Typography>
    </Grid>
  )
}

export default Safety
